<template>
  <div @mouseover="showTooltip" @mouseleave="hideTooltip" ref="tooltipContainer">
    <p v-show="isVisible" class="hover-tooltip-text z-max text-sm fixed"
       :style="tooltipStyle">
      {{ tip }}
    </p>
    <slot/>
  </div>
</template>

<script setup>
import {reactive, ref, watchEffect} from "vue";

const props = defineProps({
  tip: {
    type: String,
    required: true,
  },
  placement: {
    type: String,
    default: "right",
    validate: (value) => ["right", "bottom-right", "top", "left", "bottom"].includes(value),
  },
});

const tooltipContainer = ref(null);
const isVisible = ref(false);
const tooltipStyle = reactive({top: "0px", left: "0px"});

const showTooltip = () => {
  isVisible.value = true;
  updatePlacement();
};

const hideTooltip = () => isVisible.value = false;

watchEffect(() => {
  if (!tooltipContainer.value) return;
  updatePlacement();
});

const updatePlacement = () => {
  const containerRect = tooltipContainer.value.getBoundingClientRect();

  switch (props.placement) {
  case "right":
    tooltipStyle.top = `${containerRect.top + window.scrollY}px`;
    tooltipStyle.left = `${containerRect.right + 10 + window.scrollX}px`;
    break;
  case "bottom-right":
    tooltipStyle.top = `${containerRect.bottom + 10 + window.scrollY}px`;
    tooltipStyle.left = `${containerRect.right + window.scrollX}px`;
    break;
  case "top":
    tooltipStyle.top = `${containerRect.top - 10 + window.scrollY}px`;
    tooltipStyle.left = `${containerRect.left + window.scrollX}px`;
    break;
  case "left":
    tooltipStyle.top = `${containerRect.top + window.scrollY}px`;
    tooltipStyle.left = `${containerRect.left - 10 + window.scrollX}px`;
    break;
  case "bottom":
    tooltipStyle.top = `${containerRect.bottom + 10 + window.scrollY}px`;
    tooltipStyle.left = `${containerRect.left + window.scrollX}px`;
    break;
  }
};
</script>

<style scoped>
.hover-tooltip-text {
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  white-space: nowrap;
  z-index: 1;
}
</style>
